import _ from "lodash";
import { RECEIVE_PHUKET_SKYPARK } from "../actions/actionType";
import {
  fetchGalleryApi,
  fetchConceptApi,
  fetchMasterPlanApi,
  fetchSitePlanApi,
  fetchResidenceApi,
  fetchDestinationApi,
  fetchSanctuaryClubApi
} from "../services/phuket-skypark";

const initAppPhuketSkypark = () => {
  return async dispatch => {
    const listApi = [];
    listApi.push({ key: "gallery", data: await fetchGalleryApi() });
    listApi.push({ key: "concept", data: await fetchConceptApi() });
    listApi.push({ key: "masterPlan", data: await fetchMasterPlanApi() });
    listApi.push({ key: "sitePlan", data: await fetchSitePlanApi() });
    listApi.push({ key: "residence", data: await fetchResidenceApi() });
    listApi.push({ key: "destination", data: await fetchDestinationApi() });
    listApi.push({ key: "sanctuaryClub", data: await fetchSanctuaryClubApi() });
    try {
      const apiResult = await Promise.all(listApi);
      const mapData = _.reduce(
        apiResult,
        (result, value, index) => {
          const { key, data } = value;
          return {
            ...result,
            [key]: data
          };
        },
        {}
      );
      dispatch({
        type: RECEIVE_PHUKET_SKYPARK,
        data: mapData
      });
    } catch (err) {
      console.error("initAppPhuketSkypark err", err);
    }
  };
};

export { initAppPhuketSkypark };



// WEBPACK FOOTER //
// ./src/actions/phuket-skypark.js